import React from "react";

import { BundleGroupTypes } from "../../../constants";
import { ICompareTile } from "../../../models/product-compare";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { IRootState } from "../../../store/reducers.interfaces";
// eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
import { setSelectedUpgrade } from "../../configurator/reducers";
import {
    baseVariantSelector,
    rootProductSelector,
    upgradeBundlesSelector,
    // eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
} from "../../configurator/selectors";
import { defaults } from "../defaults";
import { ProductCompareUpgradeTile as ProductCompareUpgradeTileComponent } from "./ProductCompareUpgradeTileContent";

export const ProductCompareUpgradeTile = (props: {
    tile: ICompareTile;
}): React.ReactNode => {
    const dispatch = useAppDispatch();

    const state = useAppSelector(
        (rootState: IRootState) => rootState.configurator || defaults,
    );
    const rootProduct = useAppSelector((rootState: IRootState) =>
        rootProductSelector(rootState.configurator),
    );
    const baseVariant = baseVariantSelector(state);
    const pageRootProduct = rootProduct ? rootProduct.id : null;
    const selectedUpgrade = state.ui.selectedUpgrade;
    const upgradeBundles = upgradeBundlesSelector(
        state.entities.concreteBundles,
        baseVariant,
        BundleGroupTypes.UPGRADE_PRODUCT,
    );

    const isSelected = selectedUpgrade ? true : false;

    // An empty-product tile has no root product to upgrade; render nothing
    // rather than passing `undefined` into the leaf's `product` deref.
    const tileRootProduct = props.tile.rootProducts.at(0);
    if (!tileRootProduct) {
        return null;
    }

    return (
        <ProductCompareUpgradeTileComponent
            product={tileRootProduct}
            selectedUpgrades={
                selectedUpgrade
                    ? [
                          {
                              productID: selectedUpgrade,
                              quantity: 1,
                          },
                      ]
                    : []
            }
            isSelected={isSelected}
            pageRootProduct={pageRootProduct}
            onSelectionChange={(updates) => {
                if (updates.length > 0) {
                    const update = updates[0];
                    dispatch(
                        setSelectedUpgrade(
                            update.quantity > 0 ? update.productID : null,
                        ),
                    );
                }
            }}
            upgradeBundles={upgradeBundles}
        />
    );
};
